import React, { useState } from "react";
import "./Blogs.css";
import { Container, Row, Col } from "react-bootstrap";
import Blogbody from "./Blogbody";

const sampleBlogs = [
  {
    id: 1,
    title: "Modern Web Solutions for Growing Businesses",
    category: "Web-Solutions",
    slug: "web-solutions-guide",
    author: { name: "Ahsan" },
    description: `In the digital age, your website is your storefront. 
Web solutions today go far beyond basic sites. 
They include speed, responsiveness, SEO, and user trust. 
A good web presence builds credibility and drives conversions. 
Businesses must invest in modern tools and design trends. 
Here’s what makes a web solution effective.`,
    publishedAt: "2024-11-08",
    blog_image: { url: "/images/Web-App-Design-.webp" },
  },
  {
    id: 2,
    title: "Why 3D Motion Graphics Are the Future",
    category: "3D-Motion",
    slug: "3d-motion-future",
    author: { name: "Ali" },
    description: `3D motion graphics are changing how we tell stories. 
They create depth, realism, and strong emotional impact. 
From ads to explainers, they boost visual engagement. 
Brands now use 3D for product showcases and storytelling. 
This tech blends art, animation, and interactivity. 
Let’s explore why 3D motion is in high demand.`,
    publishedAt: "2024-10-28",
    blog_image: { url: "/images/3D-Motion.png" },
  },
  {
    id: 3,
    title: "UI/UX Design – Beyond Just Pretty Interfaces",
    category: "UI/UX",
    slug: "uiux-design-tips",
    author: { name: "Nida" },
    description: `UI/UX is more than design—it’s user experience strategy. 
It solves problems through structure, flow, and interaction. 
Users love apps that are simple and intuitive. 
Great UX means fewer drop-offs and more engagement. 
Modern businesses rely on UI/UX for digital success. 
Here’s what defines a winning user experience.`,
    publishedAt: "2024-09-20",
    blog_image: { url: "/images/modern-web-solutions.webp" },
  },
  {
    id: 4,
    title: "Video Editing – Crafting the Perfect Story",
    category: "Video-Editing",
    slug: "video-editing-tips",
    author: { name: "Shahzaib" },
    description: `Good editing transforms raw footage into powerful stories. 
It sets the tone, rhythm, and emotional beats. 
From social media clips to long-form docs, it matters. 
Video editing involves cutting, transitions, sound, and effects. 
It can make or break your final output’s quality. 
Here’s what makes editing impactful and cinematic.`,
    publishedAt: "2024-08-15",
    blog_image: { url: "/images/video-editing.jpg" },
  },
  {
    id: 5,
    title: "Mastering After Effects for Motion Design",
    category: "After Effects",
    slug: "after-effects-motion",
    author: { name: "Maira" },
    description: `After Effects is the go-to tool for motion designers. 
From logo reveals to character animation—it does it all. 
It adds dynamic energy to your content and UI. 
Visual effects, kinetic typography, or compositing—AE handles it. 
It’s used in ads, intros, explainer videos, and more. 
Here’s why learning AE is a creative power move.`,
    publishedAt: "2024-07-10",
    blog_image: { url: "/images/after-effects.jpg" },
  },
  {
    id: 6,
    title: "Graphic Design That Converts and Communicates",
    category: "Graphics-Design",
    slug: "graphic-design-converts",
    author: { name: "Sarah" },
    description: `Graphic design is communication with a purpose. 
It blends typography, imagery, and layout into one message. 
Brands use it for identity, marketing, and product visuals. 
A great design connects emotionally and stays memorable. 
It's not just art—it drives business goals and clarity. 
Here’s what makes design truly effective.`,
    publishedAt: "2024-06-30",
    blog_image: { url: "/images/graphic-design.webp" },
  },
];

const categories = [
  "All",
  "UI/UX",
  "Graphics-Design",
  "3D-Motion",
  "Video-Editing",
  "Web-Solutions",
  "After Effects",
];

const BlogPage = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");

  const filteredBlogs =
    selectedCategory === "All"
      ? sampleBlogs
      : sampleBlogs.filter((blog) => blog.category === selectedCategory);

  return (
    <Container className="my-5">
      <h1 className="text-center blog-h mb-5">Explore Our Latest Blogs</h1>

      {/* Categories */}
      <Row className="justify-content-center mb-4">
        {categories.map((cat) => (
          <Col
            xs="auto"
            key={cat}
            className={`text-center category ${
              selectedCategory === cat ? "active" : ""
            }`}
            onClick={() => setSelectedCategory(cat)}
          >
            {cat}
          </Col>
        ))}
      </Row>

      {/* Featured */}
      <Row className="align-items-center blog-feature">
        <Col md={7}>
          <img
            className="image-placeholder"
            src={sampleBlogs[0].blog_image.url}
            alt={sampleBlogs[0].title}
            onError={(e) => (e.target.src = "/images/fallback.jpg")}
          />
        </Col>
        <Col md={5}>
          <p className="text-muted">FEATURED</p>
          <h2>{sampleBlogs[0].title}</h2>
          <p>{sampleBlogs[0].description}</p>
          <p className="text-muted">
            <strong>{sampleBlogs[0].author.name}</strong>
            <br /> Author | {sampleBlogs[0].publishedAt}
          </p>
        </Col>
      </Row>

      <Blogbody blogs={filteredBlogs} />
    </Container>
  );
};

export default BlogPage;
